module.exports = __webpack_public_path__ + "static/media/aboutusmobile.c7d9eab9.jpg";